import { render } from "./HomeLayout.vue?vue&type=template&id=c6f21938"
const script = {}

import "./HomeLayout.vue?vue&type=style&index=0&id=c6f21938&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__